export default "__VITE_ASSET__BykfXc$J__"